import React from 'react'
import classnames from 'classnames'
import injectStyles from 'react-jss'

import { styles } from './styles'

const Timeline = ({
  items,
  activeIndex,
  isEditMode,
  classes,
  onEdit = () => {},
}) => (
  <div className={classes.wrapper}>
    {items.map((step, index) => (
      <div
        key={step.value}
        className={classnames(classes.step, {
          done: activeIndex >= index,
          edit: isEditMode,
        })}
        style={index ? { width: `${100 / (items.length - 1)}%` } : null}
        onClick={() => onEdit(step, index)}
      >
        <span className={classes.title}>{step.label}</span>
        <i className={classes.marker} />
      </div>
    ))}
  </div>
)

export default injectStyles(styles)(Timeline)



// WEBPACK FOOTER //
// ./src/Components/TimeLine/index.js